import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { VentricularAssistDeviceConstants } from '../../procedures/ventricularAssistDevice/store/ventricularAssistDevice.constants'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { addVentricularAssistDeviceItem } from '../../timeline/store/timeline.actions'
import { resetState } from '../../procedures/ventricularAssistDevice/store/ventricularAssistDevice.actions'
import { IQuickActionsState } from '../store/quickActions.types'

export function* saveVentricularAssistDeviceQuickActionTimeLineRow() {
  const quickActionsObject: IQuickActionsState = yield select(getQuickActionsSelector)
  const { addVentricularAssistDeviceToTimeline } = quickActionsObject
  try {
    if (addVentricularAssistDeviceToTimeline) {
      yield put(addVentricularAssistDeviceItem())
      yield put(resetState())
    }
  } catch (e) {
    yield put(throwPcrException(`saveVentricularAssistDeviceQuickActionTimeLineRow() error: ${e}`))
  }
}

export function* saveVentricularAssistDeviceQuickActionTimeLineRowSaga() {
  yield takeLatest(
    [VentricularAssistDeviceConstants.SET_ADD_TO_TIMELINE],
    saveVentricularAssistDeviceQuickActionTimeLineRow
  )
}
